import { History } from 'history';
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';

import LoginPage from '../containers/account/LoginPage';
import RegistrationPage from '../containers/account/RegistrationPage';
import AgentResaleOfferPortal from '../containers/agentResaleOfferFlow/AgentResaleOfferPortal';
import BrokerageOfferFlow from '../containers/brokerageOfferFlow/BrokerageOfferFlow';
import ErrorPage from '../containers/ErrorPage';
import HomePage from '../containers/HomePage';
import NotFoundPage from '../containers/NotFoundPage';
import ResaleClosingDashboard from '../containers/resaleClosingDashboard/ResaleClosingDashboard';
import ResaleClosingDashboardIndex from '../containers/resaleClosingDashboard/ResaleClosingDashboardIndex';
import ExternalOfferEmail from '../externalTooling/ExternalOfferEmail';
import ExternalOfferLogin from '../externalTooling/ExternalOfferLogin';
import { errorPagePath } from './pathBuilders';

function renderRoutes(history: History) {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route path={'/login'} component={LoginPage} />
        <Route path={'/register'} component={RegistrationPage} />

        <Route path={errorPagePath} component={ErrorPage} />

        <Route path="/brokerage-offers/:token" component={BrokerageOfferFlow} />

        <Route
          path="/(makeoffer|makeoffers|make-offer|make-offers)/:page?"
          component={AgentResaleOfferPortal}
        />

        <Route path="/closing-dashboard/:listingOfferId" component={ResaleClosingDashboard} />
        <Route path="/closing-dashboard" component={ResaleClosingDashboardIndex} />

        <Route path="/external_tooling/v1/compose-offer/:token" component={ExternalOfferEmail} />
        <Route path="/external_tooling/v1/login-page/:token" component={ExternalOfferLogin} />
        <Route path="/" component={HomePage} />
        <Route component={NotFoundPage} />
      </Switch>
    </ConnectedRouter>
  );
}

export default renderRoutes;
